import { updateView } from '../../current-view/actions/updateView';
import { KNOWLEDGE_BASE, ARTICLE, CATEGORY, CATEGORY_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import { setSelectedCategory } from '../../knowledge-base/reducers/kbLibrarySlice';
import { navigateToKnowledgeBaseArticle } from './navigateToKnowledgeBaseArticle';
import { getKnowledgeBaseUrl } from '../../selectors/widgetDataSelectors/getKnowledgeBaseUrl';
export function navigateToKBContent(target) {
  return (dispatch, getState) => {
    switch (target.type) {
      case KNOWLEDGE_BASE:
        dispatch(updateView(KNOWLEDGE_BASE));
        break;
      case ARTICLE:
        {
          const deepLink = getKnowledgeBaseUrl(getState());
          if (!deepLink) {
            break;
          }
          dispatch(updateView(KNOWLEDGE_BASE));
          dispatch(navigateToKnowledgeBaseArticle({
            hubSpotContentId: target.articleId,
            deepLink,
            hubSpotContentTextFragment: ''
          }));
          break;
        }
      case CATEGORY:
        dispatch(setSelectedCategory({
          id: Number(target.categoryId),
          name: '',
          openedFromSdk: true
        }));
        dispatch(updateView(CATEGORY_VIEW));
        break;
      default:
        dispatch(updateView(KNOWLEDGE_BASE));
    }
  };
}